import {
    ActionCreatorWithPayload, CaseReducer, createAsyncThunk,
} from '@reduxjs/toolkit'

import {
    NinchatChannelUpdatedEvent, NinchatEventType,
} from '../types/events'

import {
    NinchatClientPromiseValue, NinchatEventActionPayload,
} from 'api/NinchatClient'

import {
    extractProperties,
    isEmpty,
} from './'

import {
    RootState,
} from 'store'

import {jitsiHangup} from 'actions/jitsi'

type ChannelUpdatedAsyncThunk = typeof thunk & {reducer: CaseReducer} & ChannelUpdatedActionCreator

type ChannelUpdatedActionCreator = ActionCreatorWithPayload<NinchatEventActionPayload<NinchatChannelUpdatedEvent>, 'NINCHAT/event/channel_updated'>

type ChannelUpdatedAsyncThunkConfig = {
    state: RootState
}

const eventTypePrefix = 'NINCHAT/event'

const thunk = createAsyncThunk<NinchatClientPromiseValue, NinchatChannelUpdatedEvent, ChannelUpdatedAsyncThunkConfig>(
    `${eventTypePrefix}/${NinchatEventType.NinchatChannelUpdatedEvent}`,
    async (event, thunkAPI) => {
        const {
            channel_id, channel_attrs,
        } = event

        const {
            activeVideoChannelId, isActive,
        } = thunkAPI.getState().jitsi

        // if there is active jitsi meeting and someone closed the channel
        if (isActive && activeVideoChannelId === channel_id && channel_attrs.closed) {
            await thunkAPI.dispatch(jitsiHangup())
        }

        return event
    },
)

export const channelUpdated = thunk as ChannelUpdatedAsyncThunk

channelUpdated.reducer = (state, action) => {
    const {
        event_cause, // eslint-disable-line @typescript-eslint/no-unused-vars
        channel_attrs,
        channel_id,
        realm_id,
        ...rest
    } = extractProperties<NinchatChannelUpdatedEvent>(action.payload)

    isEmpty(rest)

    // if its not my channel do nothing
    if (!state.user_channels[channel_id]) {
        return
    }

    state.user_channels[channel_id] ??= {channel_attrs: {}}

    state.user_channels[channel_id].channel_attrs = channel_attrs
    state.user_channels[channel_id].realm_id = realm_id
}
